import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { EntityType, Entity } from 'src/app/models/entities.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class EntitySearchService {

  constructor(
    private api: ApiService

  ) { }


  public search(term: string, entityType?: EntityType): Observable<Entity[]> {
    const params: any = { term };
    if (entityType) {
      params.sources = entityType;
    }

    return this.api.get<Entity[]>(`entity/search`, params).pipe(map(res => res.payload));
  }

}
